export default {
  accept: "aceitar",
  accept_work_update: "aceitar actualização de obra",
  accepted: "aceite",
  acquirer: "Adquirente",
  active: "activo",
  adaptor: "adaptador",
  add: "adicionar",
  add_heir: "adicionar herdeiro",
  add_interested_party: "adicionar titular",
  add_licensee: "adicionar usuário",
  add_name: "adicionar nome",
  add_party: "adicionar indivíduo",
  add_performer: "adicionar artista",
  add_title: "adicionar título",
  added: "adicionado",
  added_lyrics: "letra adicionada",
  additional: "adicional",
  additional_names: "nomes adicionais",
  address: "morada",
  administration_costs: "comissões administrativas",
  administrator: "Gestor",
  affiliations: "filiações",
  agreement: "contrato",
  agreement_conflict: "conflito em contrato",
  agreement_conflicts: "conflitos em contratos",
  agreement_created: "contrato criado",
  agreement_deleted: "contrato eliminado",
  agreement_is_in_conflict: "Este contrato está em conflito com outro contrato",
  agreement_is_inactive: "Este contrato não pode ser editado porque está inactivo",
  agreement_updated: "contrato actualizado",
  agreements: "contratos",
  agreements_uploads: "carregamentos de contratos",
  air_date_time: "data e hora de emissão",
  album: "álbum",
  allocate: "atribuir",
  allocate_distribution: "atribuir distribuição",
  allocated: "atribuído",
  allocating: "a atribuir",
  allocation_process_successfully_triggered: "o processo de atribuição foi accionado com sucesso",
  alternate_titles: "títulos alternativos",
  alternative_title: "título alternativo",
  amount: "montante",
  an_email_with_instructions_for_reset_pass_has_been_sent: "foi enviado um e-mail com instruções para repor a palavra-passe",
  and: "e",
  applied: "aplicado",
  arrangement: "arranjo",
  arranger: "Arranjador",
  artist: "artista",
  assignee: "cessionário",
  assignee_name_search: "assignee name search",
  assignor: "cedente",
  assignor_name_search: "assignor name search",
  at: "em",
  atlas_id: "Atlas ID",
  author: "Autor da Letra",
  automatched: "codificado automaticamente",
  back: "retorno",
  back_to_distribution: "retorno à distribuição",
  back_to_distributions: "retorno às distribuições",
  back_to_login: "retorno ao login",
  back_to_results: "retorno aos resultados",
  bank_amount: "montante bancário",
  blocked: "bloqueado",
  board_member: "membro da direcção",
  bulk_works_upload: "carregamento massivo de obras",
  but: "mas",
  ca_e_link: "ligação CA/E",
  cable: "cabo",
  cancel: "cancelar",
  candidate: "candidata",
  candidate_matched: "candidata foi codificado com sucesso",
  candidates: "candidatas",
  chained_to: "ligado a",
  changed: "alterado",
  cinema: "cinema",
  claimed_mec: "parte mecânica reclamada",
  claimed_per: "parte de execução reclamada",
  claimed_total: "total reclamado",
  clear_filters: "limpar filtros",
  clear_selected: "limpar seleccionadas",
  click_to_select_file_or_drag_and_drop: "clicar para seleccionar ficheiro ou arrastar e largar",
  close: "fechar",
  close_distribution: "fechar distribuição",
  closed: "fechado",
  code: "código",
  collection_date: "data de cobrança",
  comment: "comentário",
  comment_deleted: "comentário eliminado",
  comment_saved: "comentário guardado",
  comment_updated: "comentário actualizado",
  comments: "comentários",
  complete: "completo",
  composer: "Compositor",
  concerts: "concertos",
  confirm_allocate_distribution: "Está prestes a efetuar a atribuição para todos os lotes desta distribuição. Deseja continuar?",
  confirm_close_distribution: "Uma vez encerrada, a distribuição e todos os seus lotes não podem ser editados ou eliminados. Os membros não serão notificados enquanto a distribuição não for publicada.",
  confirm_create_agreement: "Os dados fornecidos no contrato poderão gerar um conflito com o(s) seguinte(s) contrato(s). Quer mesmo assim criar o contrato?",
  confirm_delete_agreement: "Quer mesmo eliminar este contrato?",
  confirm_delete_comment: "Quer mesmo eliminar este comentário?",
  confirm_delete_distribution: "Quer mesmo eliminar este ciclo de distribuição? Serão perdidas todas as definições e atribuições. Esta eliminação é irreversível.",
  confirm_delete_distribution_pool: "Quer mesmo eliminar este lote de distribuição?",
  confirm_delete_exclusion_file: "do you really want to delete this exclusion file",
  confirm_delete_heir: "Quer mesmo eliminar este herdeiro?",
  confirm_delete_interested_party: "Quer eliminar este titular?",
  confirm_delete_pro_rata_file: "Quer mesmo eliminar este ficheiro pro-rata?",
  confirm_delete_usage_file: "Este ficheiro de uso e os seus dados serão eliminados. Quer mesmo eliminá-los?",
  confirm_delete_user: "Quer mesmo eliminar este utilizador?",
  confirm_delete_works: "Quer mesmo eliminar esta obra",
  confirm_demerge_work: "confirmar desenlace de obras",
  confirm_email: "confirmar e-mail",
  confirm_generate_crd_report: "Quer pedir ficheiros CRD para esta distribuição? Poderá descarregar os relatórios assim que estiverem gerados.",
  confirm_member_work_update: "As duas alterações serão revista por um Administrador antes de serem aplicadas",
  confirm_publish_distribution: "Esta acção irá disponibilizar os relatórios de distribuição aos membros. Deseja continuar?",
  confirm_undo_allocation: "Quer reverter as atribuições? Todas as atribuições deste lote serão removidas.",
  confirm_undo_distribution_allocation: "Quer reverter as atribuições de todos os lotes desta distribuição? Todas as atribuições deste lote serão removidas.",
  confirm_unmatch_usage: "Quer mesmo descodificar este uso?",
  confirm_update: "confirmar actualização",
  conflict: "conflito",
  conflict_detected: "conflito detectado",
  conflict_detected_user_action_created: "Foi detectado um conflito e criada uma interação a executar.",
  conflict_with_existing_work: "Os dados de obra que forneceu estão em conflito com  uma obra existente e foi criada uma interação",
  conflicting_agreement: "contrato conflituoso",
  contact: "contacto",
  contact_name: "nome de contacto",
  contact_updated: "dados de contacto actualizado",
  continue: "continue",
  contributor: "titular",
  contributor_roles: "categorias de titular",
  contributors: "titulares",
  copy: "copiar",
  copy_configuration_from: "copiar configuração de",
  copyright_free: "livre de direitos",
  country: "país",
  crd_files: "ficheiros CRD",
  crd_matching: "codificação de CRD",
  crd_pool: "lote de CRD",
  crd_reports: "Relatórios CRD",
  crd_reports_confirmation: "Confirmar carregamento de Relatórios CRD",
  crd_successfully_matched: "crd codificado com sucesso",
  create: "criar",
  create_agreement: "criar contrato",
  create_crd_distribution_pool: "criar lote de distribuição CRD",
  create_digital_distribution_pool: "criar lote de distribuição PRONTO",
  create_distribution: "criar distribuição",
  create_distribution_pool: "criar lote de distribuição",
  create_new_user_for: "criar um novo utilizador para",
  create_non_ipi_party: "Criar um titular não IPI",
  create_pool: "criar lote",
  create_recording: "criar gravação",
  create_vod_distribution_pool: "criar lote de distribuição VOD",
  create_work: "criar obra",
  created: "criado",
  created_by: "criado por",
  creation_date: "data de criação",
  currency: "moeda",
  current: "actual",
  date_of_birth: "Data de Nascimento",
  date_of_death: "Data de Falecimento",
  dates: "datas",
  day: "dia",
  declare_new_work: "declarar uma nova obra",
  decline: "recusar",
  decline_work_update: "recusar actualização de obra",
  declined: "recusado",
  deductibles: "dedutíveis",
  delete: "eliminar",
  delete_agreement: "eliminar contrato",
  delete_distribution: "eliminar distribuição",
  delete_distribution_pool: "eliminar lote de distribuição",
  delete_exclusion_file: "delete exclusion file",
  delete_heir: "eliminar herdeiro",
  delete_interested_party: "eliminar titular",
  delete_pro_rata_file: "eliminar este ficheiro",
  delete_usage_file: "eliminar o ficheiro de uso",
  delete_user: "eliminar utilizador",
  delete_work: "eliminar obra",
  deleted: "eliminado",
  demerge: "desenlaçar",
  demerge_message: "A seguinte fonte será desenlaçada desta obra",
  demerged: "desenlaçada",
  demerged_work: "obra desenlaçada",
  description: "descrição",
  detach_all_files: "separar todos os ficheiros",
  detach_file: "separar ficheiro",
  detach_sheet: "separar lista",
  different_spelling: "Diferente Ortografia",
  digital_files: "ficheiros de digital",
  digital_pool: "Lote do PRONTO",
  distributable: "a distribuir",
  distributable_net: "montante líquido a distribuir",
  distribution: "distribuição",
  distribution_cycles: "distribution cycles",
  distribution_errors: "erros de distribuição",
  distribution_pool_successfully_created: "foi criado correctamente um lote de distribuição",
  distribution_pool_successfully_deleted: "foi eliminado correctamente um lote de distribuição",
  distribution_pool_successfully_edited: "foi editado com correctamente um lote de distribuição",
  distribution_successfully_closed: "distribuição encerrada correctamente",
  distribution_successfully_created: "distribuição criada correctamente",
  distribution_successfully_deleted: "distribuição eliminada correctamente",
  distribution_successfully_edited: "distribuição editada correctamente",
  distribution_successfully_published: "distribuição publicada correctamente",
  distributions: "distribuições",
  do_you_want_to_accept_this_update: "Quer aceitar esta actualização?",
  do_you_want_to_continue: "Quer continuar?",
  do_you_want_to_decline_this_update: "Quer recusar esta actualização?",
  domestic_pool: "lote local",
  done: "feito",
  download_crd_reports: "descarregar relatórios CRD",
  download_current_file: "descarregar o ficheiro actual",
  download_prorata_file_template: "descarregar o modelo de ficheiro pro-rata",
  download_qa_reports: "descarregar relatórios QA",
  download_template: "descarregar modelo",
  download_works_list: "descarregar lista de obras",
  dsp: "FSI",
  duplicates_not_allowed: "não são permitidas duplicações",
  duration: "duração",
  edit: "editar",
  edit_crd_distribution_pool: "editar lote de distribuição CRD",
  edit_digital_distribution_pool: "editar lote de distribuição PRONTO",
  edit_distribution: "editar distribuição",
  edit_distribution_pool: "editar lote de distribuição",
  edit_shares: "Editar %",
  edit_tags: "editar etiquetas",
  edit_vod_distribution_pool: "editar lote de distribuição VOD",
  edit_work: "editar obra",
  edited: "editado",
  editing_multiple_tags_warning: "As seguintes etiquetas serão aplicadas a todos os ficheiros seleccionados. Se não for especificada uma etiqueta, quaisquer etiquetas existentes serão removidas dos ficheiros.",
  email: "E-mail",
  end: "fim",
  end_date: "data de fim",
  error: "erro",
  errors: "erros",
  events: "eventos",
  exclude: "excluir",
  exclusion_file_deleted: "exclusion file deleted",
  exclusions: "exclusions",
  existing_agreements: "contratos existentes",
  extra_search_title: "Pesquisa extra",
  field: "campo",
  file_errors: "erros de ficheiros",
  file_not_attached: "ficheiro não está anexado",
  file_successfully_uploaded: "ficheiro carregado correctamente",
  filename: "nome do ficheiro",
  files: "ficheiros",
  first_line_of_text: "primeira linha de texto",
  first_name: "primeiro nome",
  for: "para",
  form_contains_errors: "O formulário contém erros. Queira verificar toda a informação inserida",
  formal_title: "título formal",
  from: "de",
  full_name: "nome completo",
  fund_id: "Ident do fundo",
  funds: "Fundos",
  general: "geral",
  general_users: "utilizadores gerais",
  generate_UP1_report: "Gerar um ficheiro UP1",
  go_to: "ir para",
  go_to_agreement_conflict: "ir para conflito em contrato",
  go_to_detail_page: "ir para página de detalhe",
  go_to_user_action: "ir para interação do utilizador",
  go_to_work: "ir para obra",
  go_to_works_matching_user_action: "ir para codificação de obras",
  gross_amount: "bruto",
  has_files: "tem ficheiros",
  heir_deleted: "herdeiro eliminado",
  heirs: "herdeiros",
  hide_reviewed: "ocultar revistos",
  high: "Alta",
  history: "história",
  holding_reference: "HR",
  inactive: "inactivo",
  include: "incluir",
  include_exclude: "incluir/excluir",
  income_participant: "Beneficiário",
  incoming_work: "obra recebida",
  incomplete: "incompleto",
  incorrect_title: "título incorrecto",
  ingested: "inserido",
  ingestion_stats: "estatísticas de inserções",
  inheritance_date: "data de herança",
  interested_parties: "titulares",
  interested_party: "titular",
  interested_party_name: "nome do titular",
  interested_party_number: "número do titular",
  invalid_ipi_base_number: "IPI Base Number inválido",
  invalid_isrc: "IRSC inválido",
  invalid_iswc: "ISWC inválido",
  ip_matching_stats: "estatísticas de identificação de IP",
  ipi_base_number: "IPI Base Number",
  ipi_information: "Informação do IPI",
  ipi_name_number: "IPI Name Number",
  ipi_number: "Número IPI",
  ipi_status: "Estado do IPI",
  ipi_status_1: "IP auto-referenciado válido",
  ipi_status_2: "Aquisição",
  ipi_status_3: "Eliminação lógica com referência cruzada",
  ipi_status_4: "Eliminação lógica total sem referência cruzada",
  isrc: "ISRC",
  iswc: "ISWC",
  item: "objecto",
  iteration: "iteração",
  karaoke: "karaoke",
  landed: "Carregado para Processamento",
  landing_db_ingestion: "Pronto para Processamento",
  language: "idioma",
  last_name: "apelido",
  last_run: "última execução",
  latest: "mais recente",
  legal_name: "Nome",
  less: "menos",
  licensee: "usuário",
  link: "link",
  link_recording: "enlace de gravação",
  linked: "enlaçado",
  linked_to_existing_work: "a obra foi enlaçada com uma obra existente",
  linked_work: "obra enlaçada",
  login: "login",
  logout: "logout",
  low: "baixo",
  lyrical_adaptations: "adaptações de letras",
  mandates: "mandatos",
  manually_created: "criada manualmente",
  manually_linked: "enlaçado manualmente",
  manually_matched: "codificado manualmente",
  mark_as_reviewed: "marcar como revisto",
  marked_for_deletion: "marcado para eliminação",
  match: "codificar",
  matched: "codificado",
  matched_by: "codificado por",
  matched_work: "obra codificada",
  matching_stats: "estatísticas de codificação",
  mechanical: "mecânicos",
  medium: "médio",
  member: "Membro",
  member_reports: "relatórios de membros",
  member_reports_download: "descarregar relatórios de distribuição",
  member_reports_processing: "a processar relatórios de distribuição",
  member_reports_request: "Pedir relatórios de distribuição",
  member_work_matching_message: "Esta declaração de obra é um potencial duplicado e está pendente de revisão por parte da Documentação.",
  member_work_update_notice: "Pode acompanhar quaisquer alterações pendentes no separador “actualizações de obra” existente dentro do detalhe da obra.",
  membership_status: "estado de filiação",
  merge: "enlaçar",
  merge_works: "enlaçar obras",
  merging_more_than_three_works_not_allowed: "não é permitido enlaçar mais do que três obras",
  merging_not_allowed_for_non_domestic_works: "não é permitido enlaçar obras de repertório internacional",
  metadata: "metadados",
  modification: "Modificação",
  modified_lyrics: "letra modificada",
  modified_version: "versão modificada",
  month: "mês",
  more: "mais",
  more_information: "mais informação",
  music_added_to_text: "música adicionada a texto",
  music_arrangement: "Arranjo musical",
  music_video: "vídeo musical",
  my_profile: "O meu perfil",
  my_works: "As minhas obras",
  name: "nome",
  name_search: "pesquisa de nome",
  names: "nomes",
  nationalities: "nacionalidades",
  net_distributable_amount: "líquido",
  new_lyrics_added: "nova letra adicionada",
  new_music_added: "nova música adicionada",
  new_work_created: "Nova obra criada com sucesso",
  no: "não",
  no_chained_shares: "Sem % partilhada",
  no_crd_reports: "Relatórios CRD indisponíveis",
  no_distribution_reports_for_member: "Não está contemplado com nenhum pagamento neste período de distribuição e por isso os relatórios estão desactivados.",
  no_files: "sem ficheiros",
  no_lyrics: "sem letra",
  no_member_reports: "Relatórios de Membro indisponíveis",
  no_parties_found: "não existem titulares",
  no_payments_for_you: "Não está contemplado com nenhum pagamento neste período de distribuição e por isso os relatórios estão desactivados.",
  no_performers_for_this_work: "não foram declarados intérpretes para esta obra.",
  no_qa_reports: "Relatórios de Qualidade",
  no_shares: "Sem %",
  no_sources_found: "não foram encontradas fontes para esta obra",
  no_stats_info_available: "as estatísticas não estão disponíveis",
  no_work_report: "O relatório de obra não está disponível",
  non_ipi: "Não IPI",
  not_current: "fora de uso",
  nothing_has_been_selected: "não foi nada seleccionado",
  on: "em",
  only_alpha_numeric_characters_allowed: "apenas caracteres alfa-numéricos permitidos",
  only_domestic: "apenas obras domésticas",
  only_with_usages: "apenas com Utilizações",
  original: "original",
  original_lyrics: "letra original",
  original_music: "música original",
  original_publisher: "Editor Original",
  original_sound_track: "gravação sonora original",
  original_title: "título original",
  original_title_translated: "título original traduzido",
  other_reference: "Outros",
  override_distribution: "substituir distribuição",
  overview: "visão geral",
  own_works: "obras próprias",
  part_title: "título parcial",
  parties: "titulares",
  party: "titular",
  password: "palavra-passe",
  patronym: "Patrónimo",
  payees: "beneficiários",
  pending: "pendente",
  pending_allocation: "pendente de atribuição",
  pending_for_validation: "pendente de validação",
  pending_updates: "actualizações pendentes",
  per_and_mec: "PER e MEC",
  per_duration: "por duração",
  per_play: "por execução",
  per_weighted_play: "por execução ponderada",
  percent: "percentagem",
  performer: "intéprete",
  performers: "intérpretes",
  performing: "execução",
  period: "período",
  play_count: "número de execuções",
  plays: "execuções",
  please_check_your_inbox: "por favor, veja a sua caixa de e-mail",
  pool: "lote",
  pool_must_be_created_before_attaching: "Tem que ser criado um lote de distribuição antes de se anexar um ficheiro pro-rata",
  pools: "lotes",
  preferred: "preferred",
  preferred_iswc: "ISWC preferred",
  primary: "principal",
  primary_address: "morada principal",
  primary_email: "e-mail principal",
  primary_phone: "telefone principal",
  priority: "prioridade",
  privacy_policy: "política de privacidade",
  pro_rata_equal: "Pro-rata – igual",
  pro_rata_file_deleted: "ficheiro pro-rata eliminado com sucesso",
  pro_rata_percentage: "Pro-rata - % por beneficiário",
  processing: "em processamento",
  processing_crd_reports: "a processar ficheiros CRD",
  products_not_found: "não foram declaradas gravações para esta obra",
  pronto_pre_distribution: "Pré-distribuição do PRONTO",
  proprietary_id: "Ident proprietário",
  pseudonym_groups: "Pseudónimo de Grupos",
  pseudonym_of_individuals: "Pseudónimo",
  public_domain: "domínio público",
  publish: "publicar",
  publish_distribution: "publicar distribuição",
  published: "publicado",
  published_date: "data de publicação",
  publisher: "editor",
  publisher_name: "nome do editor",
  publisher_roles: "categorias de editor",
  qa_reports: "Relatórios de Qualidade",
  queued_for_processing: "adicionado à lista de processamento",
  radio: "rádio",
  reason: "justificação",
  reconciled: "reconciliado",
  reconciliation: "reconciliação",
  recording: "gravação",
  recording_conflict: "conflito de gravações",
  recording_conflict_help_text: "A gravação no topo está actualmente ligada às seguintes obras. Seleccione uma obra e a gravação será removida das restantes.",
  recording_conflicts: "gravações em conflito",
  recording_details: "detalhes da gravação",
  recording_release: "edição da gravação",
  recording_successfully_created: "A gravação foi criada com sucesso",
  recording_successfully_linked: "A gravação foi enlaçada com sucesso",
  recording_successfully_unlinked: "A gravação foi desenlaçada com sucesso",
  recording_title: "título da gravação",
  recording_type: "tipo da gravação",
  recordings: "gravações",
  refresh: "refrescar",
  register: "registar",
  remitting_society_distribution_identifier: "Código de distribuição da sociedade remetente",
  remove: "remover",
  repertoire_admin: "administração de repertório",
  replaced_lyrics: "letra substituída",
  report_generation_confirmation: "confirmação de geração de relatório",
  report_generation_has_successfully_been_initiated: "geração de relatório iniciada com sucesso",
  request_changes: "pedir alterações",
  request_member_reports: "pedir relatórios de Membros",
  request_reports_success: "Os relatórios foram pedidos e serão enviados para o seu e-mail logo que estejam disponíveis",
  request_sent: "Pedido enviado. O relatório estará disponível brevemente",
  request_work_report: "Pedir relatórios de obras",
  requested_by: "pedido por",
  reset_password: "repor palavra-passe",
  resolution: "resolução",
  resolved_by: "resolvido por",
  restricted_title: "título restrito",
  right_types: "tipos de direitos",
  rights: "direitos",
  ring_back_tone: "Ring back tone",
  role: "categoria",
  rule: "regra",
  rules: "regras",
  rules_change_warning: "Esta alteração às regras irá desanexar todos os ficheiros anexados ao lote. Deseja continuar?",
  save: "Guardar",
  search: "pesquisar",
  search_and_select: "pesquisar e seleccionar",
  search_by: "pesquisar por",
  search_by_artist: "artista",
  search_by_atlas_id: "Atlas ID",
  search_by_filename: "nome de ficheiro",
  search_by_ipi_number: "Por número de IPI",
  search_by_iswc_atlas_id_or_work_code: "ISWC, ATLAS ID, SPA",
  search_by_name: "nome",
  search_by_name_or_complete_ipi_number: "Nome ou Número de IPI completo",
  search_by_party_id: "código do titular",
  search_by_party_name: "Nome do Compositor ou do Editor",
  search_by_party_number: "número de titular",
  search_by_performer: "número do titular",
  search_by_title: "Nome do Intérprete ou do Artista",
  search_by_title_or_alternate_titles: "Título Original ou Alternativo",
  search_existing_works: "pesquisar obras existentes",
  search_ipi_db: "Pesquisar IPI",
  search_non_ipi_parties: "Pesquisar titulares que não constam no IPI",
  search_results: "resultados da pesquisa",
  secondary_email: "E-mail alternativo",
  secondary_phone: "telefone alternativo",
  select_agreement: "seleccionar contrato",
  select_candidate: "seleccionar candidato",
  select_date_range: "seleccionar o período",
  select_option: "seleccionar opção",
  select_priority: "seleccionar prioridade",
  select_product_type: "seleccionar tipo de produto",
  select_recording_type: "seleccionar tipo de gravação",
  select_this_work: "seleccionar esta obra",
  select_use_type: "seleccionar tipo de uso",
  selected: "seleccionados",
  selected_files: "ficheiros seleccionados",
  sender: "remetente",
  sender_currency: "moeda do remetente",
  server_error_message: "Ocorreu uma anomalia, queira contactar os serviços",
  service: "serviço",
  set_as_preferred_iswc: "definir como ISWC Preferred",
  share: "%",
  shares: "% cessão",
  show_distribution: "mostrar a chave de distribuição",
  show_members_only: "mostrar apenas Membros",
  show_non_ipi_only: "mostrar apenas titulares não-IPI",
  show_source_metadata: "mostrar metadados fonte",
  signup_confirmation: "Acedeu correctamente. Estamos a analisar a sua inscrição. Aguarde até que a sua conta seja activada.",
  single_view_ingestion: "inserção na Consulta de Obras",
  society: "sociedade",
  society_admin: "Documentação",
  sound_recording: "gravação sonora",
  source: "fonte",
  sources: "fontes",
  specific: "específico",
  split: "divisão",
  standardized_spelling: "Ortografia Standard",
  start: "início",
  start_date: "data de início",
  stats: "estatísticas",
  status: "estado",
  sub_arranger: "Sub-arranjador",
  sub_author: "Sub-autor",
  submit_for_review: "submeter para revisão",
  submitted_by: "submetido por",
  substituted_publisher: "Editor Substituto",
  synchronisation: "sincronização",
  tag_filters: "filtros de etiquetas",
  tagging_was_successful: "etiquetagem com sucesso",
  termination_date: "data de fim",
  territories: "territórios",
  territory: "território",
  the_following_errors_have_to_fixed_for_allocation_to_run: "devem ser corrigidos os seguintes erros para ser possível efectuar a atribuição",
  this_field_confirm_does_not_match: "este campo de confirmação não corresponde",
  this_field_is_required: "este campo é obrigatório",
  this_field_must_be_a_valid_email: "este campo tem que ser um e-mail válido",
  title: "título",
  to: "para",
  total: "total",
  total_unique: "total único",
  transaction: "transacção",
  translated_lyrics: "letra traduzida",
  translator: "Tradutor",
  tv: "TV",
  type: "tipo de",
  unallocated: "por atribuir",
  undo_allocation: "reverter atribuição",
  undo_allocation_success: "reversão de atribuição com sucesso",
  unlink: "desenlaçar",
  unmatch: "descodificar",
  unmatch_confirmation: "confirmação da descodificação",
  unmatched: "por codificar",
  unspecified: "por especificar",
  up1_report_confirmation: "será gerado um relatório dos seguintes ficheiros e enviado um link de descarregamento para este e-mail",
  update: "actualização",
  update_user: "actualizar utilizador",
  upload: "carregamento",
  upload_date: "data de carregamento",
  upload_exclusion_file: "upload exclusion file",
  upload_pro_rata_file: "carregar ficheiro pro-rata",
  uploaded_by: "carregado por",
  uploader: "carregador",
  usage_file_successfully_marked_for_deletion: "ficheiro de Utilização marcado para eliminação com sucesso",
  usage_files: "ficheiros de Utilização",
  usage_period: "período da Utilização",
  usage_successfully_matched: "Utilização codificada com sucesso",
  usage_successfully_unmatched: "Utilização descodificada com sucesso",
  usages_matching: "codificação de Utilizações",
  use_type: "tipo de Utilização",
  user: "utilizador",
  user_action: "intervenção do utilizador",
  user_actions: "intervenções do utilizador",
  user_email: "e-mail do utilizador",
  user_email_field_help_text: "este e-mail será utilizado para aceder à aplicação",
  user_name: "nome de utilizador",
  user_name_field_help_text: "este nome identifica um utilizador que pode aceder à aplicação",
  user_updated: "utilizador actualizado",
  user_with_provided_email_doesnt_exist: "Não existe um utilizador com o e-mail fornecido",
  users: "utilizadores",
  view: "ver",
  view_in_works_database: "Ver na base de dados de obras",
  view_user_action: "ver intervenção do utilizador",
  view_work: "ver obra",
  vod_files: "Ficheiros de VOD",
  vod_pool: "Lote de VOD",
  warning: "alerta",
  week: "semana",
  wex_remitted_royalty_amount: "Valor total recebido",
  which_work_do_you_want_to_keep: "Qual a obra que deseja manter?",
  with_up: "atribuir a PI",
  without_up: "não atribuir a PI",
  work: "obra",
  work_code: "código de obra",
  work_codes: "códigos de obra",
  work_detail: "detalhe de obra",
  work_edit_to_be_reviewed: "O seu pedido de alteração foi submetido com sucesso e será verificado pela Documentação.",
  work_id: "Ident. Obra",
  work_matching: "codificação de obras",
  work_matching_stats: "estatísticas de codificação de obras",
  work_registration: "declaração de obra",
  work_registration_conflict: "Esta declaração de obra é uma possível duplicação, clique no link para ir para a intervenção de utilizador a executar",
  work_registration_created: "Esta obra foi criada com sucesso, clique no link abaixo para ver os detalhes.",
  work_registration_details: "detalhes da declaração de obra",
  work_registration_linked: "Esta declaração de obra foi identificada como duplicação e foi enlaçada com uma obra existente, clique no link para ver os detalhes.",
  work_registration_to_be_reviewed: "A sua declaração de obra foi submetida com sucesso e será verificada pela Documentação.",
  work_report: "relatório de obra",
  work_selected: "obra seleccionada",
  work_successfully_created: "obra criada com sucesso",
  work_successfully_deleted: "obra eliminada com sucesso",
  work_successfully_demerged: "obra desenlaçada com sucesso",
  work_successfully_updated: "obra actualizada com sucesso",
  work_title: "título de obra",
  work_type: "tipo de obra",
  work_update_accepted: "actualização de obra aceite",
  work_update_declined: "actualização de obra recusada",
  work_updates: "actualização de obras",
  works: "obras",
  works_list_for_party_will_be_emailed: "A gerar ficheiro contendo todas as obras deste titular e assim que estiver disponível será enviado um link de descarregamento via e-mail.",
  works_list_for_you_will_be_emailed: "A gerar ficheiro contendo todas as suas obras e assim que estiver disponível será enviado um link de descarregamento via e-mail.",
  works_matching: "codificação de obras",
  works_search_by: "pesquisa de obras do editor por título, título alternativo ou ISWC",
  works_single_view: "consulta de obras",
  works_successfuly_merged: "obras enlaçadas com sucesso",
  works_with_non_ipi_ips: "obras com titulares não-IPI",
  wrong_role_for_party: "profissão do titular inválida",
  yes: "sim",
  your_email: "o seu e-mail",
}
